/* eslint-disable */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button, message, Tooltip } from 'antd';
import MaterialButton from '@/components/MaterialButton';
import RepeatDisclaimer from '@/components/RepeatDisclaimer';
import TypeBadge from '@/components/TypeBadge';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';

import { TOPIC_IMAGE } from '@shared/constants/topic-image';
import { getDefaultMaterialImage, isCorpCourseWithOrWithoutApprove } from '@shared/utils/topic-utils';

import Utils from '@/Utils';
import classNames from 'classnames';
import dayjs from 'dayjs';
import _ from 'lodash';
import PropTypes from 'prop-types';

import css from './CompilationDetail.module.scss';

import { ADD_REPEAT } from '@/constants/studyPlanStatus';
import { TOPIC_TYPES } from '@/constants/topic-types';

class MaterialCard extends Component {
  static propTypes = {
    eventTopicInfo: PropTypes.func,
    isExternalLogin: PropTypes.bool,
    getFile: PropTypes.func,
    name: PropTypes.string,
    onStudyPlanClick: PropTypes.func,
    startDate: PropTypes.string,
    topic: PropTypes.object,
    type: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      cover:
        props.topic.type && isCorpCourseWithOrWithoutApprove(props.topic.type.id)
          ? this.props.corpCourseBackground || getDefaultMaterialImage(props.topic.type.id)
          : TOPIC_IMAGE.find(type => type.id === props.topic.type.id).image,
      schedule: null,
      readyToBackground: false,
    };
  }

  componentDidMount() {
    const { topic } = this.props;
    this.getTopicInfo(topic);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.corpCourseBackground !== prevProps.corpCourseBackground) {
      const { topic } = this.props;
      if (!topic.thumbFileUuid && isCorpCourseWithOrWithoutApprove(topic.type.id)) {
        const cover = this.props.corpCourseBackground || getDefaultMaterialImage(props.topic.type.id);
        this.setState({ cover });
      }
    }
  }

  handleStudyPlanClick = async () => {
    const { onStudyPlanClick, topic, t } = this.props;
    const isRepeat = topic?.userPlanType === ADD_REPEAT;

    const disclaimerResult = isRepeat && (await RepeatDisclaimer.Modal());
    if (disclaimerResult || !isRepeat) {
      const isEventType = topic?.type?.id === 8;

      if (topic.isTopicFull && isEventType) {
        message.warning(t('topicFull'));
        return;
      }

      if (onStudyPlanClick) {
        onStudyPlanClick(topic.id, topic.type, topic.startDate, {
          id: topic.id,
          independent: topic.independent,
          startDate: topic.startDate,
          topicCost: topic.cost,
          link: topic?.firstLink || topic?.link || (topic?.links && topic?.links?.[0]?.url),
          eventCount: topic.futureEvents,
          topicComment: topic.comment,
        });
      }
    }
  };

  getTopicInfo = topic => {
    if (this.props.isExternalLogin && topic.scope !== 'EXTERNAL') {
      const topicImage = TOPIC_IMAGE.find(type => type.id === 404);
      this.setState({ cover: topicImage && topicImage.image });
    } else {
      const thumbUuid = topic.thumbFileUuid;
      if (thumbUuid) {
        this.props.getFile(thumbUuid, blob => {
          const cover = URL.createObjectURL(blob);
          if (cover) {
            this.setState({
              cover,
              readyToBackground: true,
            });
          }
        });
      } else if (isCorpCourseWithOrWithoutApprove(topic.type.id)) {
        const cover = this.props.corpCourseBackground || getDefaultMaterialImage(this.props.topic.type.id);
        this.setState({ cover });
      }
    }
    if (topic.type && (isCorpCourseWithOrWithoutApprove(topic.type.id) || topic.type.id === 20) && topic.event) {
      this.props.eventTopicInfo(topic.event.id, schedule => this.setState({ schedule }));
      this.setState({ eventNotFound: false });
    } else {
      this.setState({ eventNotFound: true });
    }
  };

  render() {
    const { topic, name, type, isExternalLogin, t } = this.props;
    const { cover } = this.state;
    const topicType = type && _.find(TOPIC_TYPES(this.props.t), item => item.id === type.id);

    const typeBadge = topicType && (
      <TypeBadge small noText portraitPlaceholder={false} type={topicType.code} name={type.name} />
    );

    const ellipsisName = name.length < 150 ? name : `${name.substring(0, 150)}...`;

    return (
      <div className={css.UserCard} key={topic.id}>
        <div className={css.UserCard__content}>
          <div
            className={css.UserCard__image}
            style={this.state.readyToBackground && cover ? { backgroundColor: topic.coverColor } : {}}
          >
            <img src={cover} alt='' />
            {typeBadge}
            {topic.cost > 0 && <div className={css.UserCard__cost}>{topic.cost} ₽</div>}
          </div>
          <div className={css.UserCard__title}>
            {!isExternalLogin && topic.scope === 'INTERNAL' ? (
              <Tooltip title={t('blocked')} placement='top'>
                <div className={css['UserCard__title-disabled']}>
                  <Tooltip title={name.length > 150 && name} placement='bottom'>
                    {ellipsisName}
                  </Tooltip>
                </div>
              </Tooltip>
            ) : (
              <Link data-qa='userCompilationMaterialLink' to={`/collection-topics/${topic.id}`}>
                {name.length < 150 ? name : <Tooltip title={name}>{ellipsisName}</Tooltip>}
              </Link>
            )}
          </div>
        </div>

        <MaterialButton topic={topic} inline className={css['Detail-btn-container']} />

        <RepeatDisclaimer />
      </div>
    );
  }
}

export default withTranslation(['listItem', 'constants'])(MaterialCard);
